import { Ionicons } from '@expo/vector-icons';
import * as Clipboard from 'expo-clipboard';
import Lottie from 'lottie-react-web';
import React from 'react';
import { TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';
import { IconSvg } from 'src/assets';
import { Container, CustomQRCode, RegularText, Row, SizedBox, TicketStatus } from 'src/components';
import { DateTimeCalendar } from 'src/components/layout/DateTimeCalendar';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { TicketTab } from './TicketTab';

interface Props {
  ticket: QRCodeTicketProps;
  ticketTabbar: number;
  setTicketTabbar: React.Dispatch<React.SetStateAction<number>>;
  reservationsLength: number;
}

export const QRCodeTicket = React.forwardRef(
  ({ ticket, ticketTabbar, setTicketTabbar, reservationsLength }: Props, ref) => {
    console.log({ seats: ticket.seats });
    return (
      <Container ref={ref} style={{ overflow: 'hidden', marginTop: -1 }} width="100%" backgroundColor={AppColors.white}>
        <Container
          paddingTop={metrics.large}
          width="100%"
          style={{ backgroundColor: AppColors.primary, justifyContent: 'center', alignItems: 'center' }}>
          {/* <CustomFastImage height={pixelScaler(146)} width={pixelScaler(146)} source={Assets.TicketBackground} /> */}
          <Container>
            <CustomQRCode data={ticket?.qrcodeData} />

            <QRCodeBlurContent status={ticket?.status} />
          </Container>
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={async () => {
              try {
                await Clipboard.setStringAsync(ticket?.qrcodeData);
                Toast.show({
                  text1: `Ticket number ${ticket?.qrcodeData} Copied`,
                  // visibilityTime: 10000,
                  type: 'success',
                });
              } catch (error) {
                Toast.show({
                  text1: 'Information',
                  text2: 'Error',
                  // visibilityTime: 10000,
                  type: 'error',
                });
              }
            }}>
            <Row middle marginTop={metrics.medium} marginBottom={metrics.large}>
              <RegularText fontWeight="bold" color={AppColors.white}>
                ID: {ticket?.qrcodeData}
              </RegularText>
              <SizedBox width="medium" />
              <Ionicons color={AppColors.white} name="copy-outline" size={pixelScaler(14)} />
            </Row>
          </TouchableOpacity>
          {reservationsLength > 1 && (
            <Container width="100%" paddingTop={metrics.huge}>
              <TicketTab value={ticketTabbar} onChange={setTicketTabbar} />
            </Container>
          )}
          <IconSvg.TicketLine />
        </Container>
        {ticket?.status === 'pending' ? (
          <Row
            style={{ alignItems: 'center', justifyContent: 'center' }}
            backgroundColor={AppColors.primary}
            padding={metrics.large}>
            <Container marginRight={metrics.large}>
              <Lottie
                height={pixelScaler(34)}
                width={pixelScaler(34)}
                options={{
                  loop: true,
                  animationData: require('src/assets/lotties/loading.json'),
                }}
              />
            </Container>
            <RegularText color={AppColors.white} textLang="paymentIsBeingProcessed" />
          </Row>
        ) : (
          <Container backgroundColor={AppColors.primary} padding={metrics.large}>
            <Row marginBottom={metrics.small} style={{ alignItems: 'center' }}>
              <Container flex>
                <DateTimeCalendar
                  lineColor={AppColors.white50}
                  color={AppColors.white}
                  iconColor={AppColors.white50}
                  fontWeight="bold"
                  date={ticket?.date || ''}
                  time={ticket?.time}
                />
              </Container>

              {ticket?.status === 'Canceled' || ticket?.status === 'Departed' ? (
                <TicketStatus status={ticket?.status} />
              ) : (
                <RegularText color={AppColors.white} fontWeight="bold">
                  {ticket?.checkedInSeatsCount}/{ticket?.seatCount}{' '}
                  <RegularText color={AppColors.white50}>used</RegularText>
                </RegularText>
              )}
            </Row>
            <Row width="100%">
              <Container marginRight={metrics.medium} height={pixelScaler(20)} align="center">
                <IconSvg.Seats fill={AppColors.white50} />
              </Container>
              <Row style={{ flex: 1, flexWrap: 'wrap', flexGrow: 1, alignContent: 'flex-start', width: '100%' }}>
                {ticket.seats.map((seat, index) => (
                  <SeatNumber
                    key={index.toString()}
                    seat={seat}
                    index={index}
                    seatLength={ticket?.seats.length}
                    status={ticket?.status}
                  />
                ))}
              </Row>
            </Row>
          </Container>
        )}

        {/* <Container
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            alignItems: 'center',
            justifyContent: 'center',
            height: pixelScaler(146),
            width: pixelScaler(146),
          }}>
          {(ticket?.status === 'Departed' || ticket?.status === 'Canceled') && (
            <Container
              style={{
                position: 'absolute',
                alignSelf: 'center',
                width: 100,
                height: 100,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {ticket?.status === 'Departed' && (
                <Container
                  align="center"
                  style={{ height: 40, width: 40, borderRadius: 20, backgroundColor: AppColors.yellow }}>
                  <IconSvg.BigCheck fill={AppColors.white} />
                </Container>
              )}
              {ticket?.status === 'Canceled' && (
                <Container
                  align="center"
                  style={{ height: 40, width: 40, borderRadius: 20, backgroundColor: AppColors.red }}>
                  <IconSvg.BigClose fill={AppColors.white} />
                </Container>
              )}
            </Container>
          )}
        </Container>
      </Container> */}
        {/* <Container flex padding={metrics.medium}>
        <Row flex style={{ justifyContent: 'flex-end' }}>
          {ticket?.status && <TicketStatus status={ticket?.status} />}
        </Row>
        <Container style={{ alignSelf: 'center' }}>
          <DateTimeCalendar fontWeight="bold" fontSize="medium" date={ticket?.date || ''} time={ticket?.time} />

          <Row marginTop={metrics.small} style={{ alignItems: 'center' }}>
            <Container height={pixelScaler(18)} marginRight={metrics.medium}>
              <IconSvg.Seats fill="#CACACA"/>
            </Container>

            <RegularText fontSize="medium" fontWeight="bold">
              x {ticket.seatCount}
            </RegularText>
          </Row>
          <Row marginTop={metrics.small} style={{ alignItems: 'center' }}>
            <Container height={pixelScaler(18)} marginRight={metrics.medium}>
              <IconSvg.CircleCheck />
            </Container>

            <RegularText fontSize="medium" fontWeight="bold">
              {ticket.remaining}
            </RegularText>
          </Row>
        </Container>
        <Container flex />
      </Container> */}
      </Container>
    );
  },
);

const QRCodeBlurContent = ({ status }: { status: 'Upcoming' | 'pending' | 'Canceled' | 'Departed' }) => {
  if (status === 'Upcoming') return null;

  return (
    <Container
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}>
      <Container
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: AppColors.black80,
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: metrics.borderRadius,
        }}>
        {status !== 'pending' ? (
          <Container
            style={{
              borderRadius: 100,
              height: pixelScaler(50),
              width: pixelScaler(50),
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: status === 'Departed' ? AppColors.yellow : AppColors.red,
            }}>
            {status === 'Departed' ? <IconSvg.BigCheck /> : <IconSvg.BigClose />}
          </Container>
        ) : (
          <Container />
        )}
      </Container>
    </Container>
  );
};

const SeatNumber = ({
  seat,
  index,
  status,
  seatLength,
}: {
  seat: { name: string; isChecked: boolean };
  index: number;
  seatLength: number;
  status: string;
}) => {
  const borderRadiusStyle = {
    borderTopLeftRadius: index === 0 ? pixelScaler(2) : 0,
    borderBottomLeftRadius: index === 0 ? pixelScaler(2) : 0,
    borderTopRightRadius: index === seatLength - 1 ? pixelScaler(2) : 0,
    borderBottomRightRadius: index === seatLength - 1 ? pixelScaler(2) : 0,
  };

  const removePaddingLeftStyle = {
    paddingLeft: (index === 0 && !seat.isChecked) || status === 'Departed' ? 0 : metrics.small,
  };

  const isHighlight = seat.isChecked && status !== 'Departed';
  // eslint-disable-next-line no-nested-ternary
  const borderRightWidth = status === 'Departed' ? 0 : index < seatLength - 1 && seat.isChecked ? 1 : 0;

  return (
    <Row middle>
      <Container
        key={index.toString()}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: metrics.tiny,
          height: pixelScaler(20),
          paddingHorizontal: metrics.small,
          borderColor: AppColors.white50,
          backgroundColor: isHighlight ? AppColors.white50 : 'transparent',
          borderRightWidth,
          ...removePaddingLeftStyle,
          ...borderRadiusStyle,
        }}>
        <RegularText fontWeight="bold" color={AppColors.white}>
          {seat.name}
        </RegularText>
      </Container>
      {/* {index < ticket.seats.length - 1 && (
                      <Container
                        style={{
                          height: pixelScaler(16),
                          width: 1,
                          backgroundColor: AppColors.white50,
                        }}
                      />
                    )} */}
    </Row>
  );
};
